import React from 'react';
import PropTypes from 'prop-types';

function Gallery({ size, stroke, strokeWidth = 1.3, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...otherProps}
    >
      <rect
        x="5"
        y="5"
        width="14"
        height="14"
        rx="2"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.88802 11.2222C10.6244 11.2222 11.2214 10.6253 11.2214 9.88888C11.2214 9.1525 10.6244 8.55554 9.88802 8.55554C9.15164 8.55554 8.55469 9.1525 8.55469 9.88888C8.55469 10.6253 9.15164 11.2222 9.88802 11.2222Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 14.6364L15.25 11L7 19"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 17H22C22.5523 17 23 16.5523 23 16V8C23 7.44772 22.5523 7 22 7H21.5"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 7L2 7C1.44771 7 0.999999 7.44772 0.999999 8L1 16C1 16.5523 1.44771 17 2 17L2.5 17"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Gallery.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Gallery;
